import {QueryClient} from '@tanstack/react-query';

const networkMode = import.meta.env.DEV || import.meta.env.MODE === 'mob-server' ? 'always' : 'online';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 10000 * 3, // 30 seconds
            cacheTime: 10000 * 6 * 3, // 3 minutes
            retry: 3,
            networkMode,
        },
        mutations: {
            networkMode,
        },
    },
});
